<template>
    <div fluid fill-height>
      <v-expand-x-transition>
        <landing-toolbar />
      </v-expand-x-transition>
      <v-container style="min-width:100% !important">
        <MonitorCA3 />
      </v-container>
    </div>
</template>
  
  <script>
 import MonitorCA3 from '../../components/MonitorCA3/MonitorCA3.vue';
  import LandingToolbar from '../../components/LandingToolbar/LandingToolbar.vue'
  export default {
    components: { MonitorCA3, LandingToolbar },
  };
  </script>
  